import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  .ant-form-item {
    width: 100%;
    margin-bottom: 0 !important;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TitleText = styled.div`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;
export const Ol = styled.ol`
  padding-left: 16px;
  margin: 0;
`;

export const StepTitle = styled.li`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const StepSubtitle = styled.div`
  font-size: 14px;
  font-weight: 400;
`;
